"use client"

import { useEffect, useState } from "react"
import { connect, useDispatch } from "react-redux"
import { useHistory } from "react-router"
import { Formik } from "formik"
import Link from "../../../../components/Link"
import Submit from "../../../../components/FormikForm/Submit"
import { ConnectedFocusError } from "../../../../components/ConnectedFocusError"
import Snackbar from "../../../../components/Snackbar"
import { newPost, resetNewPost } from "../../../../store/actions/post"
import { getGroupById } from "../../../../store/actions/group"
import { useLayout } from "../../../../providers/LayoutProvider"
import { useWindowSize } from "../../../../hooks/useWindowSize"
import { getUrlParamByName } from "../../../../helpers/get-url-param"
import { setToZeroTimeZone } from "../../../../helpers/dates-hanlder"
import { useFileUploadProgress } from "../../../../providers/FileUploader"
import { extractMediaFileIdsFromContentObject } from "../../../../helpers/richtexteditor"
import { schema, initialValues } from "../../../../constants/forms/post/new"
import Grid from "../../../../components/Grid";
import PostFormV2 from "../components/PostFormV2"
import ModalWaitAMinute from "../New/components/ModalWaitAMinute"
import { hideModal, showModal } from "../../../../store/actions/modal"
import { Container, BottomActions, Text, FormContainer, ContentWrapper } from "./styles"

const NewPostV2 = ({
  match,
  userInformation,
  newPostInformation,
  newPostStates,
  groupInformation,
  communityInformation,
  groupType,
}) => {
  const dispatch = useDispatch()
  const { uploadFiles, resetFileUploadProgress } = useFileUploadProgress()
  const { layout, setLayout } = useLayout()
  const { isMobile } = useWindowSize()
  const history = useHistory()
  const [formSubmmited, setFormSubmmited] = useState(false)
  const [isFree, setIsFree] = useState(false)
  const [uploadingCount, setUploadingCount] = useState(0);

  const onSubmit = async ({ values, actions }) => {
    const thereAreFilesToUpload = values?.attached_files?.some((file) => file instanceof File)
    if (thereAreFilesToUpload) dispatch(showModal("modal-wait-a-minute-bis"))

    try {
      const updatedValues = {
        ...values,
        schedule_publish_at: values.schedule_publish_at ? setToZeroTimeZone(values.schedule_publish_at) : null,
        notificate_by_email: values.notificate_by_email.includes("true"),
        notificate_by_telegram: values.notificate_by_telegram.includes("true"),
        show_scheduled_post: values.show_scheduled_post.includes("true"),
        block_files_download: values.block_files_download.includes("true"),
        pinned: values.pinned.includes("true"),
        is_free: values.is_free.includes("true"),
        body_media_files_ids: extractMediaFileIdsFromContentObject(values.body),
      }

      if (thereAreFilesToUpload) {
        const uploadedFiles = await uploadFiles({ attached_files: values.attached_files }, userInformation.id, "post")
        updatedValues.attached_files = uploadedFiles.attached_files || []
      }

      dispatch(newPost(updatedValues))
    } catch (error) {
      console.error("Error during file uploads:", error)
    } finally {
      dispatch(hideModal())
    }
  }

  useEffect(() => {
    if (!groupInformation || groupInformation?.id !== Number(match?.params?.idGroup)) {
      dispatch(getGroupById({ group_id: match.params.idGroup }))
    }
  }, [match])

  useEffect(() => {
    if (newPostInformation && newPostStates.success) {
      setTimeout(() => {
        const groupId = groupInformation?.id
        const postId = newPostInformation?.id
        dispatch(resetNewPost())
        resetFileUploadProgress()
        dispatch(hideModal())
        history.push(`/group/${groupId}/p/${postId}?new=t`)
      }, 3500)
    }
  }, [newPostInformation, newPostStates])

  useEffect(() => {
    setIsFree(getUrlParamByName("t") === "f" || groupInformation?.group_type === "community")
  }, [groupInformation])

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title:
          groupInformation?.group_type === "community"
            ? "Crear contenido gratuito"
            : "Nuevo contenido",
        description: "Nuevo contenido",
      },
      dashboard: {
        tabs: {
          visible: false,
        },
      },
      header: {
        visible: true,
      },
    });
  }, [groupInformation]);

  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title:
          groupInformation?.group_type === "community"
            ? "Crear contenido gratuito"
            : "Nuevo contenido",
        description: "Nuevo contenido",
        back: groupInformation?.group_type === "free_experience"
          ? `/dashboard/community/events/${groupInformation?.id}/posts`
          : `/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/posts`,
      },
      dashboard: {
        tabs: {
          visible: false,
        },
      },
      header: {
        visible: true,
        actions: [
          <Link
            options={{
              type: "outline",
              size: "lg",
              skin: "purple",
              native: true,
            }}
            href={groupInformation?.group_type === "free_experience"
              ? `/dashboard/community/events/${groupInformation?.id}/posts`
              : `/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/posts`}
            style={{ width: "50%" }}
          >
            Cancelar
          </Link>,
          <Submit
            isSubmmiting={newPostStates.loading}
            options={{
              type: "filled",
              size: "lg",
              skin: "purple",
            }}
            form="new-post-form"
            disabled={uploadingCount > 0}
            style={{ width: "50%" }}
          >
            {uploadingCount > 0
              ? `Subiendo ${uploadingCount} archivo${uploadingCount > 1 ? 's' : ''}...`
              : "Guardar"
            }
          </Submit>,
        ],
      },
      show_whatsapp: false
    });
  }, [groupInformation, uploadingCount, newPostStates.loading]);


  const getBackUrl = () => {
    if (groupInformation?.group_type === "free_experience") {
      return `/dashboard/community/events/${groupInformation?.id}/posts`
    }
    return `/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/posts`
  }

  return (
    <Grid.Container>
      <Grid.Row>
        <Grid.Col>
          <Text>
            📝 Redacta tus artículos y sube documentos en pdf, imágenes, clases
            grabadas, videos y ¡hasta tus Reels de Instagram!
          </Text>
        </Grid.Col>
      </Grid.Row>

      <Grid.Row>
        <Grid.Col>
          <Formik
            initialValues={{
              ...initialValues,
              notificate_by_email: ["true"],
              notificate_by_telegram: ["true"],
              is_free: isFree ? ["true"] : [],
              group: groupType === "community" ? communityInformation?.id : groupInformation?.id,
            }}
            onSubmit={(values, actions) => {
              if (onSubmit) onSubmit({ values, actions })
            }}
            validateOnChange={false}
            validateOnBlur={formSubmmited}
            validationSchema={schema}
            enableReinitialize
          >
            {({ handleSubmit, ...rest }) => (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  setFormSubmmited(true)
                  handleSubmit(event)
                }}
                id="new-post-form"
              >
                <ConnectedFocusError />

                <PostFormV2 {...rest} setUploadingCount={(count) => setUploadingCount(count)} />

                {!isMobile && (
                  <BottomActions>
                    <Submit
                      isSubmmiting={newPostStates.loading}
                      options={{
                        type: "filled",
                        size: "lg",
                        skin: "purple",
                      }}
                      form="new-post-form"
                      disabled={uploadingCount > 0}
                    >
                      {uploadingCount > 0
                        ? `Subiendo ${uploadingCount} archivo${uploadingCount > 1 ? 's' : ''}...`
                        : "Guardar artículo"
                      }

                    </Submit>
                    <Link
                      options={{
                        type: "outline",
                        size: "lg",
                        skin: "purple",
                        native: true,
                      }}
                      href={getBackUrl()}
                    >
                      Cancelar
                    </Link>
                  </BottomActions>
                )}

              </form>
            )}
          </Formik>
        </Grid.Col>
      </Grid.Row>

      <ModalWaitAMinute />

      <Snackbar
        visible={newPostStates.success || newPostStates.error}
        options={{
          time: 2000,
          type: newPostStates.success ? "success" : "error",
        }}
      >
        {newPostStates.success ? "Artículo creado." : "Error al crear el artículo."}
      </Snackbar>
    </Grid.Container>
  )
}

const state = ({ groupStore, postStore, userStore, communityStore }) => {
  const { data: userInformation } = userStore.information
  const { data: newPostInformation, states: newPostStates } = postStore.newPost
  const { data: groupInformation } = groupStore.group
  const { data: communityInformation } = communityStore.community

  return {
    newPostInformation,
    newPostStates,
    groupInformation,
    communityInformation,
    userInformation,
  }
}

export default connect(state)(NewPostV2)
